import React, { useState } from 'react';
import style from './People.module.css';

const peopleData = [
  {
    id: 1,
    name: 'حجت‌الاسلام سید مهدی حسینی',
    role: 'سردبیر و مدیر مسئول',
    category: 'editorial',
    avatarIcon: 'fa-user-tie',
    gradientFrom: '#1a5f3f',
    gradientTo: '#2d8659',
    email: 'hosseini@example.com',
    phone: '+98 912 345 6789',
    telegram: 't.me/hosseini_official',
    bio: 'فارغ‌التحصیل حوزه علمیه قم با بیش از ۱۵ سال تجربه در تولید و ویرایش محتوای دینی و فرهنگی.',
    skills: ['تفسیر قرآن', 'مدیریت']
  },
  {
    id: 2,
    name: 'خانم فاطمه زهرا موسوی',
    role: 'مدیر رسانه‌های دیجیتال',
    category: 'social',
    avatarIcon: 'fa-user-graduate',
    gradientFrom: '#0f4c3a',
    gradientTo: '#1a5f3f',
    email: 'mousavi@example.com',
    instagram: 'instagram.com/fatemeh.mousavi',
    bio: 'کارشناس ارتباطات با تمرکز بر فضای مجازی اسلامی. متخصص در تولید محتوا.',
    skills: ['شبکه‌های اجتماعی', 'SEO']
  },
  {
    id: 3,
    name: 'استاد علی اکبر رضایی',
    role: 'مدرس و پژوهشگر',
    category: 'editorial',
    avatarIcon: 'fa-book-quran',
    gradientFrom: '#1a5f3f',
    gradientTo: '#4ade80',
    email: 'rezaei@example.com',
    bio: 'فارغ‌التحصیل رشته علوم قرآن و حدیث. مدرس دروس معارف اسلامی.',
    skills: ['علوم قرآنی', 'حدیث‌شناسی']
  },
  {
    id: 4,
    name: 'خانم زینب کریمی',
    role: 'تهیه‌کننده محتوای تصویری',
    category: 'content',
    avatarIcon: 'fa-video',
    gradientFrom: '#14532d',
    gradientTo: '#166534',
    email: 'karimi@example.com',
    bio: 'کارشناس تولید محتوای تصویری مذهبی. تجربه تولید مستند و کلیپ.',
    skills: ['تدوین', 'کارگردانی']
  }
];

const categories = [
  { id: 'all', label: 'همه', icon: 'fa-users' },
  { id: 'editorial', label: 'سردبیری', icon: 'fa-newspaper' },
  { id: 'social', label: 'رسانه', icon: 'fa-share-nodes' },
  { id: 'content', label: 'محتوا', icon: 'fa-video' }
];

export default function People() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredPeople = peopleData.filter(person => {
    const matchesCategory = activeCategory === 'all' || person.category === activeCategory;
    const matchesSearch = person.name.includes(searchQuery) || person.role.includes(searchQuery);
    return matchesCategory && matchesSearch;
  });

  return (
    <div className={style.peopleContainer}>
      {/* Simplified Header to focus on cards */}
      <div className={style.headerSection}>
        <h1 className={style.pageTitle}>تیم</h1>
        <p className={style.pageSubtitle}>افراد مرتبط با سایت و تولید محتوا</p>
        
        {/* Search & Filter Bar */}
        <div className={style.controlBar}>
          <div className={style.searchBox}>
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="جستجو..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div className={style.filterGroup}>
            {categories.map(cat => (
              <button
                key={cat.id}
                className={`${style.filterBtn} ${activeCategory === cat.id ? style.active : ''}`}
                onClick={() => setActiveCategory(cat.id)}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className={style.gridContainer}>
        {filteredPeople.map((person) => (
          <div key={person.id} className={style.card}>
            
            {/* 1. Large Visual Header (Simulating the Photo) */}
            <div 
              className={style.cardVisual}
              style={{
                background: `linear-gradient(180deg, ${person.gradientFrom}, ${person.gradientTo})`
              }}
            >
              <i className={`fas ${person.avatarIcon} ${style.bigIcon}`}></i>
              
              {/* The "Glass" Badge (Like the image's text overlay) */}
              <div className={style.glassBadge}>
                <span className={style.badgeDot}></span>
                {person.role}
              </div>
            </div>

            {/* 2. Content Body */}
            <div className={style.cardContent}>
              <div className={style.nameRow}>
                <h2 className={style.personName}>{person.name}</h2>
                <button className={style.actionBtn}>
                   <i className="fas fa-arrow-left"></i>
                </button>
              </div>

              <p className={style.personBio}>{person.bio}</p>

              <div className={style.footerRow}>
                <div className={style.skillStack}>
                  {person.skills.map((s, i) => (
                    <span key={i} className={style.miniTag}>{s}</span>
                  ))}
                </div>
                
                {/* Social Links */}
                <div className={style.socialLinks}>
                  {person.email && <a href={`mailto:${person.email}`}><i className="fas fa-envelope"></i></a>}
                  {person.telegram && <a href={person.telegram}><i className="fab fa-telegram"></i></a>}
                  {person.instagram && <a href={person.instagram}><i className="fab fa-instagram"></i></a>}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}